module.exports = __webpack_public_path__ + "static/media/image-icon.0c937f85.svg";